import { useContext, useMemo } from 'react';
import UFOInteractionContext from '../interaction-context';
import { getInteractionId } from '../interaction-id-context';
import { addCustomData } from '../interaction-metrics';
export default function UFOCustomData(_ref) {
  var data = _ref.data;
  var interactionContext = useContext(UFOInteractionContext);
  useMemo(function () {
    if (!interactionContext) {
      return;
    }
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') {
      interactionContext.addCustomData(globalThis.structuredClone(data));
    } else {
      interactionContext.addCustomData(data);
    }
  }, [data, interactionContext]);
  return null;
}
export function addUFOCustomData(data) {
  var interactionId = getInteractionId();
  var currentInteractionId = interactionId.current;
  if (!currentInteractionId) {
    return;
  }
  if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') {
    addCustomData(currentInteractionId, [], globalThis.structuredClone(data));
  } else {
    addCustomData(currentInteractionId, [], data);
  }
}